import { render, staticRenderFns } from "./yysd-teeth.vue?vue&type=template&id=92efa17c&scoped=true"
import script from "./yysd-teeth.vue?vue&type=script&lang=js"
export * from "./yysd-teeth.vue?vue&type=script&lang=js"
import style0 from "./yysd-teeth.vue?vue&type=style&index=0&id=92efa17c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_5qbk3fxidqh42wxgbx7uqb2gxe/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92efa17c",
  null
  
)

export default component.exports